module.exports = __webpack_public_path__ + "img/google.15be41b5.svg";